import { toast } from "sonner";
import { trackInitiateCheckout } from "./metaPixel";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Shared "Buy Now" handler: creates a single-item Shopify cart and redirects to hosted checkout.
export const buyNow = async ({ variantId, id, name, price, qty = 1, onStart, onEnd }) => {
  if (!variantId) {
    toast.info("Secure checkout is being connected", {
      description: "This piece will be purchasable shortly.",
    });
    return;
  }

  try {
    onStart && onStart();
    trackInitiateCheckout({ items: [{ id, quantity: qty }], value: (price || 0) * qty });

    const res = await fetch(`${API}/cart/checkout`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ lines: [{ variant_id: variantId, quantity: qty }] }),
    });
    const data = await res.json();
    if (data.checkout_url) {
      window.location.href = data.checkout_url;
      return;
    }
    toast.error("Couldn't reach checkout. Please try again.");
  } catch (e) {
    toast.error("Couldn't reach checkout. Please try again.");
  } finally {
    onEnd && onEnd();
  }
};
